import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between w-full mb-14" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl font-bold text-primary-700" }, " General Medical Questionnaire ", -1)
const _hoisted_3 = { class: "flex items-center space-x-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 right-0 w-4 h-4 bg-red-700 border-4 border-white rounded-full has-notif" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "mb-5 leading-loose"
}
const _hoisted_6 = { class: "mb-2 font-bold" }
const _hoisted_7 = {
  key: 0,
  class: "space-y-9"
}
const _hoisted_8 = {
  key: 1,
  class: "space-y-9"
}
const _hoisted_9 = { class: "mt-16 text-center" }
const _hoisted_10 = {
  key: 1,
  class: "space-x-5"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Please make sure all fields have been filled.", -1)
const _hoisted_13 = { class: "h-56 p-4 mt-6 overflow-auto text-left rounded-lg bg-gray-30" }
const _hoisted_14 = { class: "font-bold text-darkgray-800" }
const _hoisted_15 = { class: "list-disc pl-7" }
const _hoisted_16 = { class: "pl-7 list-[circle]" }
const _hoisted_17 = {
  key: 1,
  class: "text-darkgray-800"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "Please be informed that any changes after submission of this form cannot be applied.", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "If all the information you input is final, click “Submit”.", -1)

import UserLayout from '@/layouts/UserLayout.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import GeneralModal from '@/components/GeneralModal.vue';

import BookingInformation from './components/BookingInformation.vue';
import PersonalInformation from './components/PersonalInformation.vue';
import CompanyInformation from './components/CompanyInformation.vue';
import AllergiesInformation from './components/AllergiesInformation.vue';
import MedicalHistory from './components/MedicalHistory.vue';
import MedicationHistory from './components/MedicationHistory.vue';
import FamilyHistory from './components/FamilyHistory.vue';
import ObjectiveSymptoms from './components/ObjectiveSymptoms.vue';

import OBGYNHistory from './components/OBGYNHistory.vue';
import OccupationForm from './components/OccupationForm.vue';
import HypersensitivityReactions from './components/HypersensitivityReactions.vue';
import SpecificHealthAssessment from './components/SpecificHealthAssessment.vue';

import VaccinationHistory from './components/VaccinationHistory.vue';
import PastSurgicalHistory from './components/PastSurgicalHistory.vue';

import PageLoader from "@/components/PageLoader.vue";
import location from "@/classes/LocationService";
import auth from "@/classes/AuthService";
import MedicalService from "@/classes/MedicalService";
import ErrorModal from '@/components/ErrorModal.vue';
import patient from "@/classes/UserData";

import { ref, onMounted, watch, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { BellIcon, ExclamationTriangleIcon, UserCircleIcon } from '@heroicons/vue/24/outline';

import { 
    IPatientForm, IMedicalHistory, IMedicationHistory, 
    IFamilyHistory, IObgyneHistory, IOccupationEmployment, 
    IHypersensitivityReaction, ISpecificHealthAssessment,
    ICompanyHealthCheckup, IAllergies, IChildrenDelivery
} from '@/interfaces/PatientInterface'
import UserData from '@/classes/UserData';
import { MedicalQuestionnaireValidator, ValidationRules, type StepError } from '@/utils/medicalQuestionnaireValidation';



export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const errorMsg    = ref()
const errors      = ref([])
const showError   = ref(false)
const loader      = ref(false)
const show        = ref(false);
const showSuccess = ref(false);
const showForm = ref(false);
const step        = ref(1);
const top         = ref();
const stepErrors = ref<StepError[]>([]);
const showStepError = ref(false);
const newBooking = ref(true);
const isDependent = ref(false);

/**
 * ************************************
 * Form Data
 * ************************************
 */
const patientData                  = ref({})
const hyperSensitivityReactionData = ref({})
const medicalHistoryData           = ref({})
const medicationHistoryData        = ref({})
const familyHistoryData            = ref({})
const obgyneHistoryData            = ref({})
const objectiveSymptomsData        = ref({})
const occupationEmploymentData     = ref({})
const specificHealthAssessmentData  = ref({})
const allergiesData  = ref({})
const forCompanyHealthCheckup  = ref({})
const bookingId   = route.params.bookingId;

const patientInfo = ref(() => patient.getCurrentUser())

const vaccinations_history = ref([
    {
        vaccine_type: null,
        brand_name: null,
        number_of_doses: null,
        date_received: null,
    }
]);

const past_surgical_history = ref([
    {
        date: null,
        purpose_of_visit: null,
        findings: null,
    }
]);

const booking_information = ref({
    booking_date: null,
    patient_id: null,
})

const patientForm = ref<IPatientForm>({
  suffix           : null,
  first_name       : null,
  middle_name     : null,
  last_name       : null,
  province        : null,
  city            : null,
  barangay        : null,
  street          : null,
  building_number : null,
  zip_code        : null,
  sex             : null,
  birthdate       : null,
  telephone_number: null,
  cellphone_number: null,
  nationality     : null,
  email_address   : null,
  no_visits       : null,
  hospital        : null,
  doctor          : null,

  company_name: null,
  company_no: null,
  hmo_name: null,
  hmo_no: null,
  rank_and_file: null,
  supervisory: null,
  managerial: null,
  top_management: null,
  
  number_of_clinic_visits: null,
  family_hospital: null,
  family_doctor: null,
});

const medical_history = ref<IMedicalHistory>({
//   last_checkup: {
//     date : null,
//     where: null,
//     other: null,
//   },
//   family_hospital_doctor : null,
//   specify_family_hospital: null,
  illness_history: [{
    // is_checked    : false,
    description   : null,
    status        : null,
    family_member : [],
  }]
});

const medication_history = ref<IMedicationHistory[]>([
  {
    medication_name: null,
    illness_symptom_name: null,
    intake_schedule: null
  }
]);

const allergies = ref<IAllergies>({
    // has_allergies: false,
    // medication: null,
    // food: null,
    // specify_other: null,

    itchy_skin: false,
    rash_or_hives: false,
    swelling: false,
    itchy_eyes: false,
    watery_eyes: false,
    fatigue: false,
    coughing: false,
    shortness_of_breath: false,
    sneezing: false,
    runny_or_stuffy_nose: false,
    others: false,
    others_specify: null,
    additional_notes: null,
});

const for_company_health_checkup = ref<ICompanyHealthCheckup>({
    company_name: null,
    company_no: null,
    hmo_name: null,
    hmo_no: null,
    job_category: null,
    // TODO: Uncomment, adjust base on data structure
    // rank_and_file: null,
    // supervisory: null,
    // managerial: null,
    // top_management: null,
    test_result_option: null,
    specify_others_option: null,
});

const family_history = ref<IFamilyHistory[]>([
    {
        illness_or_condition: null,
        age_first_detected: null,
        relationship: null,
    }
])

const objective_symptoms = ref([])

const obgyne_history = ref<IObgyneHistory>({
    first_menstruation_age: null,
    is_menopause_reached: null,
    menopause_age:  null,
    is_period_regular: null,
    period_day_interval:  null,
    bleeding_duration_days:  null,
    period_flow: null,
    is_period_pain_experienced: null,
    yes_pain_experinced: null,
    are_painkillers_used: null,
    medication_name: null,
    last_period_start_date: null,
    last_period_end_date: null,
    had_sexual_intercourse: null,
    is_stds : null,
    stds_type : [],
    is_administering_hormone : null,
    specify_hormone : null,
    is_pregnant : null,
    weeks_pregnant :  null,
    been_pregnant : null,
    has_miscarriage_abortion : null,
    miscarriage_count :  null,
    abortion_count :  null,
    has_child : null,
    children_delivery : [],
    is_breastfeeding : null,
    is_breast_surgery : null,
    is_breast_tested : null,
    breast_mammography : null,
    breast_ultrasound : null,
    breast_visual_palpation : null,
    had_pap_smear : null,
    last_pap_smear_date : null,
    pap_smear_result: null,
    pap_smear_result_details :null
})

const occupation_employment = ref<IOccupationEmployment>({
    job_title : null,
    days_per_week :null,
    hours_per_day :null,
    result_delivery_option: null, // Add this new field
})

const hypersensitivity_reaction = ref<IHypersensitivityReaction>({
    rash_after_injection : {
        status : null,
        details : null
    },
    sick_dizzy_after_injection : {
        status : null,
        details : null
    },
    rash_after_meds_application : {
        status : null,
        details : null
    }
})

const specific_health_assessment = ref<ISpecificHealthAssessment[]>([
    { 
        description: 'Are you currently smoking cigarettes habitually*? 現在、習慣的にタバコを吸っている（電子タバコも含む)',
        jpnlabel: '*,Habitual: 100 cigarettes or more in total, or smoking for 6 months or more, and smoking for the last 1 month / これまで合計100本以上または6ヶ月以上の喫煙歴のある方. 過去1ヶ月間、毎日または時々喫煙をしている方' ,
        status: null,
        index: 0 
    },
    { 
        description: 'Have you gained at least 10 kg or more since age 20? 20歳以降、10kg以上の体重の増加がありましたか',
        jpnlabel: null,
        status: null,
        index: 1 
    },
    { 
        description: 'Do you perform light sweating exercises for at least 30 minutes at a time for at least 2 days a week for at least 1 year? 1回30分以上の軽い運動を週2日以上、1年以上行っていますか',
        jpnlabel: null,
        status: null,
        index: 2 
    },
    { 
        description: 'Do you walk, or have equivalent physical activity for 1 hour or more daily? 毎日1時間以上歩く、または同等の身体活動がありますか',
        jpnlabel: null,
        status: null,
        index: 3
    },
    { 
        description: 'Do you walk faster than people of the same age and sex? ほぼ同じ年齢の同性と比較して歩く速度が速いですか',
        jpnlabel: null,
        status: null,
        index: 4
    },
    { 
        description: "How fast do you usually eat?",
        jpnlabel: "人と比較して食べる速度が速いですか",
        status: null,
        index: 5
    },
    { 
        description: 'Do you eat dinner 2 hours before bedtime at least 3 times a week? 就寝前の2時間以内に夕食をとることが週に3回以上ありますか',
        jpnlabel: null,
        status: null,
        index: 6
    },
    { 
        description: 'Do you eat snacks after dinner at least 3 times a week? 夕食後に間食をとることが週に3回以上ありますか',
        jpnlabel: null,
        status: null,
        index: 7
    },
    { 
        description: 'Do you skip breakfast more than 3 times a week? 朝食を抜くことが週に3回以上ありますか',
        jpnlabel: null,
        status: null,
        index: 8
    },
    {
        description: "Do you want to improve your lifestyle such as exercise and diet? 運動やダイエットなど、生活習慣を改善したいですか",
        jpnlabel: null,
        status: null,
        index: 9
    },
    {
        description: "If you have the opportunity to receive health guidance on improving lifestyle-related diseases, would you use it? 生活習慣病を改善する保健指導を受ける機会があれば利用しますか",
        jpnlabel: null,
        status: null,
        index: 10
    },
    {
        description: "How often do you drink alcohol (sake, soju, beer, Western liquor, etc.) ? 飲酒頻度はどれくらいですか",
        jpnlabel: null,
        status: null,
        index: 11 
    },
    {
        description: "How much alcohol is consumed per day on drinking days? 飲酒日の1日あたりの飲酒量はどれくらいですか",
        jpnlabel: null,
        status: null,
        index: 12
    },
    // { 
    //     description: 'Currently taking medication to lower blood pressure',
    //     jpnlabel: '現在、血圧を下げる薬を服用中,' ,
    //     status: null,
    //     index: 9 
    // },
])

const illnesses = ref([]);

const fetchIllnessConditions = () => {
    MedicalService.fetchIllnessConditions()
    .then((result: any) => {
        illnesses.value = result.data
    })
}

/**
 * ************************************
 * Location Data
 * ************************************
 */
const provinces = ref();
const cities    = ref();
const barangays = ref();

/**
 * ************************************
 * Functions
 * ************************************
 */

const fetchData = () => {
    loader.value = true

    location.fetchProvinces()
        .then((result: any) => {
            loader.value = false
            provinces.value = result.data
        })
        .catch((err: any) => errorResponse(err) )
}

const fetchCity = () => {
    loader.value = true
    cities.value = [];
    location.fetchCities(`code=${patientForm.value.province || patientData.value.province}&level=Mun`)
    .then((result: any) => {
        loader.value = false
        cities.value = result.data
    })
    .catch((err: any) => errorResponse(err) )
}

const fetchBrgy = () => {
    loader.value = true
    barangays.value = []

    location.fetchBarangays(`code=${patientForm.value.city}&level=Bgy`)
    .then((result: any) => {
        loader.value = false
        barangays.value = result.data
    })
    .catch((err: any) => errorResponse(err) )
}

const clearCity = () => {
    if(disableInputs.value) return;

    patientForm.value.city = null
    patientForm.value.barangay = null
}

const clearBgy = () => {
    if(disableInputs.value) return;

    patientForm.value.barangay = null
}

const backToAppointment = () => {
    window.location.assign('appointment/show/' + bookingId)
}

const scrollToTop = (e: any) => {

    validateStepOne();
    const hasError = stepErrors.value.some(item => item.errors.length > 0)

    if(hasError){
        showStepError.value = true
        top.value.scrollIntoView({ behavior: "smooth" })
        return
    }

    step.value = e;
    top.value.scrollIntoView({ behavior: "smooth" })
}

/**
 * Checks if all values in an array are null or empty arrays
 * @param array The array to check
 * @returns true if all values are null or empty arrays, false otherwise
 */
const areAllValuesNull = (array: any[]): boolean => {
    return array.every(item => item === null || (Array.isArray(item) && item.length === 0));
}

const validateStepOne = () => {
    errors.value = {} as any;
    stepErrors.value = [];

    // Use the new validation utilities
    const personalInfoResult = MedicalQuestionnaireValidator.validatePersonalInformation(patientForm.value);
    const companyInfoResult = MedicalQuestionnaireValidator.validateCompanyHealthCheckup(for_company_health_checkup.value);
    const medicalHistoryResult = MedicalQuestionnaireValidator.validateMedicalHistory(medical_history.value);
    const medicationHistoryResult = MedicalQuestionnaireValidator.validateMedicationHistory(medication_history.value);
    const occupationResult = MedicalQuestionnaireValidator.validateOccupation(occupation_employment.value);
    const subjectiveSymptomsResult = MedicalQuestionnaireValidator.validateSubjectiveSymptoms(objective_symptoms.value);
    const pastSurgicalResult = MedicalQuestionnaireValidator.validatePastSurgicalHistory(past_surgical_history.value);
    const vaccinationsResult = MedicalQuestionnaireValidator.validateVaccinationsHistory(vaccinations_history.value);

    // Collect all validation errors
    const allValidationResults = [
        { result: personalInfoResult, label: 'I. Personal Information 個人情報' },
        { result: companyInfoResult, label: 'II. For Company Health Check-Up' },
        { result: occupationResult, label: 'III. Occupation 職業' },
        { result: medicalHistoryResult, label: 'IV. Medical History 病歴' },
        { result: pastSurgicalResult, label: 'V. Past Surgical History 過去の手術歴' },
        { result: medicationHistoryResult, label: 'VII. Medication History 服用中のお薬' },
        { result: vaccinationsResult, label: 'VIII. Vaccinations ワクチン接種' },
        { result: subjectiveSymptomsResult, label: 'IX. Subjective Symptoms 自覚症状' }
    ];

    // Process validation results
    allValidationResults.forEach(({ result, label }) => {
        const sectionErrors: Array<string | { index: number; errors: string[] }> = [];
        
        if (!result.isValid) {
            result.errors.forEach(error => {
                // Add to errors object for form field highlighting
                (errors.value as any)[error.field] = [error.message];
                
                // Check if this is an array validation error (contains index)
                const fieldParts = error.field.split('.');
                if (fieldParts.length > 2 && !isNaN(parseInt(fieldParts[1]))) {
                    // This is an array item error
                    const index = parseInt(fieldParts[1]);
                    let existingIndexError = sectionErrors.find(e =>
                        typeof e === 'object' && e.index === index
                    ) as { index: number; errors: string[] } | undefined;
                    
                    if (!existingIndexError) {
                        existingIndexError = { index, errors: [] };
                        sectionErrors.push(existingIndexError);
                    }
                    existingIndexError.errors.push(error.message);
                } else {
                    // Simple field error
                    sectionErrors.push(error.message);
                }
            });
        }

        stepErrors.value.push({
            label,
            errors: sectionErrors
        });
    });
}

const validateStepTwo = () => {
    errors.value = {} as any;
    stepErrors.value = [];

    // Use the new validation utilities
    const specificHealthResult = MedicalQuestionnaireValidator.validateSpecificHealthAssessment(specific_health_assessment.value);
    const obGynResult = MedicalQuestionnaireValidator.validateObGynHistory(obgyne_history.value, patientForm.value.sex !== 'Male');

    // Collect all validation results
    const allValidationResults = [
        { result: specificHealthResult, label: 'X. Specific Health Assessment / 特定健康診断' },
        { result: obGynResult, label: 'XI. OB/GYN History (For female patients only) 婦人科問診（女性のみ' }
    ];

    // Process validation results
    allValidationResults.forEach(({ result, label }) => {
        const sectionErrors: Array<string | { index: number; errors: string[] }> = [];
        
        if (!result.isValid) {
            result.errors.forEach(error => {
                // Add to errors object for form field highlighting
                (errors.value as any)[error.field] = [error.message];
                
                // Check if this is an array validation error (contains index)
                const fieldParts = error.field.split('.');
                if (fieldParts.length > 2 && !isNaN(parseInt(fieldParts[1]))) {
                    // This is an array item error
                    const index = parseInt(fieldParts[1]);
                    let existingIndexError = sectionErrors.find(e =>
                        typeof e === 'object' && e.index === index
                    ) as { index: number; errors: string[] } | undefined;
                    
                    if (!existingIndexError) {
                        existingIndexError = { index, errors: [] };
                        sectionErrors.push(existingIndexError);
                    }
                    existingIndexError.errors.push(error.message);
                } else {
                    // Simple field error
                    sectionErrors.push(error.message);
                }
            });
        }

        stepErrors.value.push({
            label,
            errors: sectionErrors
        });
    });
}
/**
 * ************************************
 * Submit Form
 * ************************************
 */

const submit = () => {
    validateStepTwo()
    console.log(stepErrors.value);
    const hasError = stepErrors.value.some(item => item.errors.length > 0)

    if(hasError){
        show.value = false
        showStepError.value = true
        top.value.scrollIntoView({ behavior: "smooth" })
        return
    }
    loader.value = true;

    // convert address code to label
    const payload = Object.assign({ 
            booking_id : bookingId,
            hospital_id : null,
        },
        {
            personal_information: patientForm.value,
            medical_history: medical_history.value,
            medication_history: medication_history.value,
            family_history: family_history.value,
            subjective_symptoms: objective_symptoms.value,
            ob_gyn_history: obgyne_history.value,
            occupation: occupation_employment.value,
            hypersensitivity_reaction: hypersensitivity_reaction.value,
            specific_health_assessment: specific_health_assessment.value,
            
            for_company_health_checkup: for_company_health_checkup.value,
            allergies: allergies.value,

            vaccinations_history: vaccinations_history.value,
            past_surgical_history: past_surgical_history.value,
        });
        let submitForm;
    if(patientData.value) {
        submitForm = MedicalService.updateMedicalQuestionnaire(payload)
    } else {
        submitForm = MedicalService.submitMedicalQuestionnaire(payload);
    }
    
    submitForm.then((response: any) => {

        show.value = false
        loader.value = false;

        if(response?.data.message == 'Unauthorized') {
            showError.value = true;
            errorMsg.value = response.message
        }else{
            showSuccess.value = true;

        setTimeout(() => {
            show.value = false;
            showSuccess.value = false;
            window.location.assign('/appointment/show/' + bookingId)
        }, 3000);
        }
    })
    .catch((err: any) => {
        loader.value = false;
        show.value = false;
        showError.value = true;

        if(err.response.status == 422) {
            errorMsg.value = err.response.data.message
            errors.value = err.response.data.errors;
            console.log(err.response.data)
        }

        if(err.response.status == 401) {
            window.location.replace('/login')
        }
    })
}

const errorResponse = (err: object) => {
    loader.value = false

    if(err.response.status == 401) {
        auth.redirectToLogin()
    }
}

const appointment = ref(null);
const fetchBooking = () => {
    loader.value = true
    
    patient.getSelectedAppointment(bookingId)
        .then((result: any) => {
            loader.value = false;
            appointment.value = result.data.response;
            if(appointment.value) {
                booking_information.value.booking_date = appointment.value.booking_date;
                booking_information.value.patient_id = appointment.value.patient.hospital_no

                // ! DEPRECATED 
                // isDependent.value = appointment.value.patient_type == 'Dependent' ? true : false;

                // if(!isDependent.value) {
                //     console.log('Not a dependent, setting medical questionnaire');
                //     // setMedicalQuestionnaire();
                // }

            } else if(result.data.response.result_status == 500) {
                showError.value = true;
                errorMsg.value = "Something went wrong. Please try again later";
            }
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;

            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

/**
 * ************************************
 * Computed Properties
 * ************************************
 */

const disableInputs  = computed(() => {
    // return newBooking.value && hyperSensitivityReactionData.value;
    // return patientData.value && hyperSensitivityReactionData.value ? true : false
    // return (newBooking.value || patientData.value && hyperSensitivityReactionData.value) ? true : false

    if(newBooking.value) {
        return false;
    }

    // ! DEPRECATED
    // if(isDependent.value) {
    //     return false;
    // }

    return true;
})

const canSubmit = ref(true);


/**
 * ************************************
 * Watchers
 * ************************************
 */
watch(
      () => patientForm.value.city,
      (val) => {
        barangays.value = [];
        if(val) fetchBrgy()
      },
      { immediate: true }
    );

watch(
    () => patientForm.value.province,
    async (val) => {
        cities.value = [];
        barangays.value = [];
        
        if(val) {
            await fetchCity()
        }
    },
    { immediate: true }
);

/**
 * Checks if a date is more than 6 months from the current date
 * @param dateToCheck Date to check (string in ISO format or Date object)
 * @param direction 'future' to check if date is >6 months in future, 'past' for past, 'both' for either
 * @returns boolean indicating if the date is more than 6 months away in the specified direction
 */
const  isDateOverSixMonths = ( dateToCheck: string | Date, direction: 'future' | 'past' | 'both' = 'future'): boolean => {
    // Parse the input date if it's a string
    const inputDate = dateToCheck instanceof Date ? dateToCheck : new Date(dateToCheck);

    // Check if the date is valid
    if (isNaN(inputDate.getTime())) {
        return false;
    }

    // Get the current date
    const currentDate = new Date();

    // Calculate the date 6 months in the future
    const sixMonthsFuture = new Date(currentDate);
    sixMonthsFuture.setMonth(currentDate.getMonth() + 6);

    // Calculate the date 6 months in the past
    const sixMonthsPast = new Date(currentDate);
    sixMonthsPast.setMonth(currentDate.getMonth() - 6);

    if (direction === 'future') {
        return inputDate > sixMonthsFuture;
    } else if (direction === 'past') {
        return inputDate < sixMonthsPast;
    } else {
        return inputDate > sixMonthsFuture || inputDate < sixMonthsPast;
    }
}

const fetchCurrentBooking = async() => {
    const booking_id = parseInt(route.params.bookingId);

    const  { data:booking } = await UserData.getSelectedAppointment(booking_id);
    patientInfo.value = booking.response.patient;
}

/**
 * Transforms string 'null' values in an object to actual null values
 * @param obj The object to transform
 * @returns A new object with string 'null' values replaced with actual null
 */
const transformNullStrings = (obj: any):any  => {
    if (obj === null || obj === undefined) {
        return obj;
    }

    // Handle arrays
    if (Array.isArray(obj)) {
        return obj.map(item => transformNullStrings(item)) ;
    }

    // Handle objects
    if (typeof obj === 'object') {
        const result: Record<string, any> = {};
        Object.keys(obj as Record<string, any>).forEach(key => {
            const value = (obj as Record<string, any>)[key];
            
            if (value === 'null') {
            result[key] = null;
            } else if (typeof value === 'object' && value !== null) {
            // Handle nested objects and arrays
            result[key] = transformNullStrings(value);
            } else {
            result[key] = value;
            }
        });
        return result;
    }

    // Handle primitives
    return (obj === 'null' ? null : obj);
};

const setMedicalQuestionnaire = async () => {

    try {
        const booking_id = parseInt(route.params.bookingId);
        
        let medicalQuestionnaire = await MedicalService.getPatientMedicalQuestionnaire(booking_id)

        if(medicalQuestionnaire.data.length == 0){ 
            newBooking.value = true;

            const previousQuestionnaire = await MedicalService.getPatientLatestMedicalQuestionnaire(patientInfo.value?.patient_id)

            if(previousQuestionnaire.data && !isDateOverSixMonths(previousQuestionnaire.data?.examination_date, 'past')){
                medicalQuestionnaire = previousQuestionnaire
            }
        } else {
            newBooking.value = false;
        }

        if(!newBooking.value) {
            canSubmit.value = false;
        }

        const response = medicalQuestionnaire;

        patientData.value                  = response.data?.personal_information;
        hyperSensitivityReactionData.value = response.data?.hypersensitivity_reaction;
        medicalHistoryData.value           = response.data?.medical_history;
        familyHistoryData.value            = response.data?.family_history;
        medicationHistoryData.value        = response.data?.medication_history; // array
        obgyneHistoryData.value            = response.data?.ob_gyn_history;
        objectiveSymptomsData.value        = response.data?.subjective_symptoms; // array
        occupationEmploymentData.value     = response.data?.occupation;
        specificHealthAssessmentData.value  = response.data?.specific_health_assessment;
        forCompanyHealthCheckup.value  = response.data?.for_company_health_check_up;
        allergiesData.value  = response.data?.allergies;

        const vaccinationHistoryData = response.data?.vaccinations_history;
        const pastSurgicalHistoryData = response.data?.past_surgical_history;

        const defaultInfo = transformNullStrings(patientData.value ?? patientInfo.value);

        Object.assign(patientForm.value, defaultInfo);
        Object.assign(hypersensitivity_reaction.value, hyperSensitivityReactionData.value);
        Object.assign(medical_history.value, medicalHistoryData.value);
        Object.assign(medication_history.value, medicationHistoryData.value);
        Object.assign(family_history.value, familyHistoryData.value);
        Object.assign(obgyne_history.value, obgyneHistoryData.value);
        Object.assign(objective_symptoms.value, objectiveSymptomsData.value);
        Object.assign(occupation_employment.value, occupationEmploymentData.value);
        Object.assign(specific_health_assessment.value, specificHealthAssessmentData.value);
        Object.assign(for_company_health_checkup.value, forCompanyHealthCheckup.value);
        Object.assign(allergies.value, allergiesData.value);

        Object.assign(vaccinations_history.value, vaccinationHistoryData);
        Object.assign(past_surgical_history.value, pastSurgicalHistoryData);

        showForm.value = true
    } catch (error) {
        show.value      = false;
        showError.value = true;
        loader.value    = false;
        console.log(error);
        if (error?.response?.status === 422) {
            errorMsg.value = error.response.data.message;
            errors.value   = error.response.data.errors;
        }
    }
}

onMounted( async() => {
    loader.value = true;

    if(!route.params.bookingId) window.location.replace('/appointment');

    // if no Bookng ID return to /overview page
    await fetchData()
    await fetchIllnessConditions()
    await fetchBooking()
    await fetchCurrentBooking()
    await setMedicalQuestionnaire();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, { color: "light" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "w-[90%] mx-auto py-10",
        ref_key: "top",
        ref: top
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "relative cursor-pointer",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(router).push('/account-details')), ["prevent"]))
            }, [
              _createVNode(_unref(UserCircleIcon), { class: "w-7 h-7" })
            ]),
            _createElementVNode("div", {
              class: "relative cursor-pointer",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(router).push('/notifications')), ["prevent"]))
            }, [
              _createVNode(_unref(BellIcon), { class: "w-7 h-7" }),
              _hoisted_4
            ])
          ])
        ]),
        (step.value == 1)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, "*By submitting your information below, you agree for SHSC, its subsidiary and/or its affiliate authorized third party contractors to process your information as set forth in our Privacy Notice found on our company website. / 以下にお客様の情報を送信することにより、SHSC、その子会社および/関連会社が認定した第三者請負業者が、当社のウェブサイトに掲載されているプライバシー通知に記載されているとおりにお客様の情報を処理することに同意したものとみなされます。"))
          : _createCommentVNode("", true),
        (showForm.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("p", _hoisted_6, "Part " + _toDisplayString(step.value == 1 ? '1' : '2') + " of 2", 1),
              (step.value == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(BookingInformation, {
                      form: booking_information.value,
                      errors: errors.value,
                      disableInputs: true
                    }, null, 8, ["form", "errors"]),
                    _createVNode(PersonalInformation, {
                      form: patientForm.value,
                      provinces: provinces.value,
                      cities: cities.value,
                      barangays: barangays.value,
                      errors: errors.value,
                      disableInputs: disableInputs.value,
                      onFetchCity: fetchCity,
                      onFetchBrgy: fetchBrgy,
                      onClearCity: clearCity,
                      onClearBgy: clearBgy
                    }, null, 8, ["form", "provinces", "cities", "barangays", "errors", "disableInputs"]),
                    _createVNode(CompanyInformation, {
                      form: for_company_health_checkup.value,
                      errors: errors.value,
                      disableInputs: disableInputs.value
                    }, null, 8, ["form", "errors", "disableInputs"]),
                    _createVNode(OccupationForm, {
                      form: occupation_employment.value,
                      disableInputs: disableInputs.value,
                      errors: errors.value
                    }, null, 8, ["form", "disableInputs", "errors"]),
                    _createVNode(MedicalHistory, {
                      disableInputs: disableInputs.value,
                      form: medical_history.value,
                      illnesses: illnesses.value,
                      errors: errors.value
                    }, null, 8, ["disableInputs", "form", "illnesses", "errors"]),
                    _createVNode(PastSurgicalHistory, {
                      form: past_surgical_history.value,
                      disableInputs: disableInputs.value,
                      errors: errors.value
                    }, null, 8, ["form", "disableInputs", "errors"]),
                    (showForm.value)
                      ? (_openBlock(), _createBlock(AllergiesInformation, {
                          key: 0,
                          form: allergies.value,
                          errors: errors.value,
                          disableInputs: disableInputs.value
                        }, null, 8, ["form", "errors", "disableInputs"]))
                      : _createCommentVNode("", true),
                    _createVNode(MedicationHistory, {
                      form: medication_history.value,
                      disableInputs: disableInputs.value,
                      errors: errors.value
                    }, null, 8, ["form", "disableInputs", "errors"]),
                    _createVNode(VaccinationHistory, {
                      form: vaccinations_history.value,
                      disableInputs: disableInputs.value,
                      errors: errors.value
                    }, null, 8, ["form", "disableInputs", "errors"]),
                    _createVNode(ObjectiveSymptoms, {
                      form: objective_symptoms.value,
                      disableInputs: disableInputs.value,
                      errors: errors.value
                    }, null, 8, ["form", "disableInputs", "errors"])
                  ]))
                : _createCommentVNode("", true),
              (step.value == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(SpecificHealthAssessment, {
                      form: specific_health_assessment.value,
                      errors: errors.value,
                      disableInputs: disableInputs.value
                    }, null, 8, ["form", "errors", "disableInputs"]),
                    (patientForm.value.sex != 'Male')
                      ? (_openBlock(), _createBlock(OBGYNHistory, {
                          key: 0,
                          form: obgyne_history.value,
                          errors: errors.value,
                          disableInputs: disableInputs.value
                        }, null, 8, ["form", "errors", "disableInputs"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                (step.value == 1)
                  ? (_openBlock(), _createBlock(ButtonComponent, {
                      key: 0,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (scrollToTop(2))),
                      text: disableInputs.value ? 'Next' : 'Go to next step'
                    }, null, 8, ["text"]))
                  : _createCommentVNode("", true),
                (step.value == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(ButtonComponent, {
                        secondary: "",
                        "show-icon": false,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (scrollToTop(1))),
                        text: "Go back"
                      }),
                      (!disableInputs.value && canSubmit.value)
                        ? (_openBlock(), _createBlock(ButtonComponent, {
                            key: 0,
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (show.value = true)),
                            text: "Submit"
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, " Loading form "))
      ], 512),
      _createVNode(GeneralModal, {
        width: "w-[548px]",
        title: "Let's Try that again",
        "action-text": "Return to Questionnaire",
        withIcon: "",
        "icon-class": "text-red-500 size-10",
        icon: _unref(ExclamationTriangleIcon),
        show: showStepError.value,
        loader: loader.value,
        onClose: _cache[5] || (_cache[5] = ($event: any) => (showStepError.value = false)),
        onConfirm: _cache[6] || (_cache[6] = ($event: any) => (showStepError.value= false))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", null, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepErrors.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.label
                }, [
                  (item.errors.length > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("p", _hoisted_14, _toDisplayString(item.label), 1),
                        _createElementVNode("ul", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.errors, (error) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: error.id
                            }, [
                              (index === 2 || index === 4)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("p", null, _toDisplayString(index === 2 ? 'Medical History' : 'Medication History') + " No. " + _toDisplayString(error.index+1), 1),
                                    _createElementVNode("ul", _hoisted_16, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(error.errors, (subError) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                          key: subError.id
                                        }, _toDisplayString(subError), 1))
                                      }), 128))
                                    ])
                                  ], 64))
                                : (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(error), 1))
                            ]))
                          }), 128))
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["icon", "show", "loader"]),
      _createVNode(GeneralModal, {
        width: "w-[548px]",
        title: "Confirm Information",
        "action-text": "Submit",
        "cancel-text": "Go back",
        show: show.value,
        loader: loader.value,
        onClose: _cache[7] || (_cache[7] = ($event: any) => (show.value = false)),
        onConfirm: submit
      }, {
        content: _withCtx(() => [
          _hoisted_18,
          _hoisted_19,
          _hoisted_20
        ]),
        _: 1
      }, 8, ["show", "loader"]),
      _createVNode(GeneralModal, {
        width: "w-[416px]",
        title: "Success!",
        content: "Your medical questionnaire has been submitted successfully.",
        "action-text": "Okay",
        show: showSuccess.value,
        onClose: _cache[8] || (_cache[8] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[9] || (_cache[9] = ($event: any) => (showSuccess.value = false))
      }, null, 8, ["show"]),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[10] || (_cache[10] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[11] || (_cache[11] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show", "errors"]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      (!showForm.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 1 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})